module.exports = __webpack_public_path__ + "img/home--offer--results.3b165d63.svg";